import React from "react";

import { IoChevronBackOutline, IoCheckmarkDone, IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { Col, Container, Nav, Row } from "react-bootstrap";

import IconTimer from "../../common/images/iconTimer.png";
import IconTimerActive from "../../common/images/iconTimerActive.png";
import Logo from "../../common/images/logo.png";
import { PALETTE } from "../../common/ThemeConstants";
import { useNavigate, useParams } from "react-router-dom";
import { useWindowWidth } from "../../api/useWindowWidth";
import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import { useSmartName } from "../../api/useSmartName";
import TimerIconTab from "./TimerIconTab";

export default function WorkoutHeader({
  title,
  image,
  showInfo,
  showCompleted = false,
  showLogo = false,
  backTo = undefined,
  onTimerClicked = () => { },
}) {
  const { idPlanDay, idWorkout, idSuperserie, idExercise } = useParams()
  const width = useWindowWidth();
  const parseName = useSmartName();
  const navigate = useNavigate();

  const goTo = () => {
    navigate(`/workout/${idPlanDay}/${idWorkout}/${idSuperserie}/${idExercise}/Details`);
  }

  return (
    <NavbarResponsive>
      <Container>
        <Nav className="flex-row">
          <div
            className="align-self-center flex back-button"
            style={{ marginRight: "1rem" }}
          >
            <IoChevronBackOutline
              onClick={() => {
                backTo === undefined ? navigate(-1) : navigate(backTo);
              }}
              size={24}
              style={{ cursor: "pointer" }}
              color={PALETTE.TRUEGRAY}
            />
          </div>
          {showInfo ? (
            <div
              style={{ textDecoration: "none" }}
              onClick={goTo}
              className="clickable"
            >
              <div className="d-flex align-items-center">
                {image && (
                  <img
                    src={image}
                    className="rounded-circle me-2"
                    alt={title}
                    style={{ width: 40, height: 40, objectFit: "cover", cursor: "pointer" }}
                  />
                )}
                <div className="text-start">
                  <p
                    className="title-clickable"
                    style={{ fontSize: 17, fontWeight: "bold", margin: 0 }}
                  >
                    {parseName(title, 17, 38)}
                  </p>
                  <span
                    className="subtitle-clickable"
                    style={{ fontSize: 13, margin: 0 }}
                  >
                    Maggiori dettagli
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <Nav style={{ textDecoration: "none" }}>
              <div className="text-center">
                <p style={{ color: PALETTE.DARK, fontSize: 17, margin: 0 }}>
                  {parseName(title, 24, 47)}
                </p>
              </div>
            </Nav>
          )}
        </Nav>
        <div style={{ width: 90 }}>
          {!showCompleted && !showLogo && (
            <Row className="m-auto align-self-center">
              <TimerIconTab
                to={""}
                image={IconTimer}
                imageHovered={IconTimerActive}
                imageActive={IconTimerActive}
                width={23}
                px={false}
                onClick={onTimerClicked}
              />
              <Col
                className="text-center align-self-center py-1 px-0"
                style={{ cursor: "pointer" }}
              >
                <IoCheckmarkDoneCircleOutline
                  color={PALETTE.TRUEGRAY}
                  className="rounded-pill"
                  size={29}
                  onClick={() => navigate(`/workout/${idPlanDay}/${idWorkout}/${idSuperserie}/${idExercise}/Completed`)}
                />
              </Col>
            </Row>
          )}
          {!showCompleted && showLogo && (
            <div className="align-self-center" style={{ width: 70 }}>
              <img
                src={Logo}
                style={{ width: "100%" }}
                alt="Federico Bartoli PT"
              />
            </div>
          )}
          {showCompleted && (
            <div className="align-self-center text-end" style={{ width: 80 }}>
              <IoCheckmarkDone
                className="shadow-sm rounded-pill p-1"
                color={PALETTE.WHITE}
                size={25}
                style={{ background: PALETTE.LINEARGRADIENT }} />
            </div>
          )}
        </div>
      </Container>
    </NavbarResponsive>
  );
}
